<script setup lang="ts">
import { PropertyProps } from "./Property.props"
import { iconsSrcMap } from "./Property.iconMapping"
import sanitizeHtml from "sanitize-html"

withDefaults(defineProps<PropertyProps>(), { markup: "md" })
</script>

<template>
  <div>
    <div class="flex items-start gap-2">
      <div v-if="iconType" class="[&>svg]:h-5 [&>svg]:w-5">
        <UtilsIcon v-bind="iconsSrcMap[iconType]" />
      </div>
      <p class="beaver-bold md:pig-bold">{{ title }}</p>
    </div>

    <UtilsMarkdown
      v-if="description && markup === 'md'"
      :content="description"
      :inline="false"
      class="markdown__product-detail-page"
    />
    <div
      v-else-if="description && markup === 'html'"
      class="html__product-detail-page"
      v-html="
        sanitizeHtml(description, {
          allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            div: ['class']
          }
        })
      "
    ></div>
  </div>
</template>

<style scoped lang="scss">
:deep(.markdown__product-detail-page) {
  table {
    @apply sm:block sm:overflow-scroll md:table md:overflow-auto;
  }
}
</style>
